import MaxicareLogo from "../../Components/MaxicareLogo";
import { useAuth } from "../../Contexts/AuthContext";
import LoginModal from "../../Components/LoginModal";
import { useNavigate } from "react-router-dom";
import Button from "../../Components/Button";
import { useEffect, useState } from "react";

function SignIn() {
  const navigate = useNavigate();
  const { setIsLocationDenied, currentPos, setCurrentPos } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setShowModal(false);
      return;
    }
    setShowModal(false);
  };

  useEffect(() => {
    const receiveMessageFromNative = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch (error) {
        console.error("Error parsing JSON:", error);
        return;
      }
      const { latitude, longitude } = data;
      setCurrentPos({ latitude, longitude });

      if (currentPos !== null) {
        setIsLocationDenied(false);
      } else {
        setIsLocationDenied(true);
      }
      navigate("/login");
    };
    window.addEventListener("message", receiveMessageFromNative);
    return () => {
      window.removeEventListener("message", receiveMessageFromNative);
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
      <div className="w-full sm:w-148 flex-grow ">
        <div className="sm:w-148 w-full sm:h-auto bg-white rounded-xl sm:mt-24">
          <div className="flex flex-col items-center justify-center ">
            <MaxicareLogo className="w-48 my-4" />

            <div className="flex flex-col items-center sm:w-full justify-center absolute inset-x-0 bottom-0 sm:relative p-4">
              <Button
                className="h-12 w-full border bg-white transition ease-in-out delay-75 hover:scale-105 rounded-xl"
                onClick={handleShow}
              >
                Activate Member Gateway Account
              </Button>
              <Button
                className="h-12 w-full mt-2 text-white transition ease-in-out delay-75 hover:scale-105 rounded-xl"
                onClick={() => {
                  if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage("loginButtonClicked");
                  } else {
                    navigate("/login");
                  }
                }}
              >
                Login
              </Button>

              <LoginModal
                isOpen={showModal}
                onClose={handleClose}
                message={
                  "Unlock wellness: Activate your Member Gateway Account!"
                }
                body={
                  "Exciting news! Register your Maxicare card today and unlock exclusive benefits. Plus, enjoy the convenience of your new account, all in one go! Ready to experience wellness at your fingertips? Let's get started!"
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
